exports = module.exports = require("../../../_css-loader@2.1.1@css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".re-component-render-error {\n  background: #f37327;\n  color: #fff;\n  line-height: 30px;\n  font-size: 14px;\n  text-align: center;\n}\n", ""]);

